import React, { useState, useEffect } from 'react'
import {
    Container, Card, Row, Col, Form, ButtonGroup,
    Button, Modal, Nav
} from 'react-bootstrap'
import PageTitle from '../components/common/PageTitle'
import api from '../api/api'
import swal from 'sweetalert'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import './AdminManagement.css'

const AllSuppliers = () => {

    const { t } = useTranslation();
    const [toggle, setToggle] = useState(false)
    const [SearchEmail, setSearchEmail] = useState('');
    const [SearchName, setSearchName] = useState('');
    const [suppliers, setSuppliers] = useState([])
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [mobilePhone, setMobilePhone] = useState("");
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [SingleSupplier, setSingleSupplier] = useState([]);

    const getSingleSupplier = async (supplierUid) => {

        let data = {
            supplier_uid: supplierUid,
        }

        await api.post('/admin/single-supplier', data)
            .then(response => {
                let supplierData = response.data.supplier;
                if (response.data.type === "success") {
                    setSingleSupplier(supplierData)
                    setName(supplierData.name)
                    setEmail(supplierData.email)
                    setAddress(supplierData.address)
                    setCity(supplierData.city)
                    setCountry(supplierData.country)
                    setMobilePhone(supplierData.tel_mobile)

                }
            }).catch(err => {
                console.error(err)
            })
        setToggle(true)
    }

    const getAllSuppliers = async () => {
        await api.get('/admin/exist-suppliers')
            .then(response => {
                let allSuppliers = response.data.suppliers

                setSuppliers(allSuppliers)
            }).catch(err => {
                console.error(err)
            })
    }

    useEffect(() => {
        getAllSuppliers()
    }, [])

    const editMySupplierData = (supplierUid) => {
        let data = {
            name: name,
            address: address,
            tel_mobile: mobilePhone,
            city: city,
            country: country,
            supplier_uid: supplierUid
        }

        api.post('/admin/edit-supplier', data)
            .then(response => {
                if (response.data.type === "success") {
                    swal(t('supplier_updated'), {
                        icon: "success",
                    });
                    setToggle(false)
                    getAllSuppliers()
                }
            }).catch(err => {
                console.error(err)
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('error')
                })
            })
    }

    const filteredSuppliers = suppliers.filter(supplier => {
        if (SearchName !== '') {
            return (
                supplier.name.toLowerCase().includes(SearchName.toLowerCase())
            )
        }
        if (SearchEmail !== '') {
            return (
                supplier.email.toLowerCase().includes(SearchEmail.toLowerCase())
            )
        }
        return supplier
    })
    return (
        <>
            <Container className="admin-management-page">
                <Row noGutters className="admin-management-heading">
                    <PageTitle
                        sm="4"
                        title={t('list_suppliers')}
                        subtitle={t('list_suppliers')}
                        className="text-sm-left"
                    />
                </Row>
                <Nav variant="pills" justified className="admin-management-tabs">
                    <Nav.Item>
                        <Nav.Link as={Link} to={`/admin/users`}>
                            {t('list_users')}
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link active>
                            {t('all_suppliers')}
                        </Nav.Link>
                    </Nav.Item>
                </Nav>

                <section className="admin-management-toolbar">
                    <div className="admin-management-toolbar-title">
                        <i className="fas fa-search" aria-hidden="true" />
                        {t('search_suppliers')}
                    </div>
                    <Row form className="admin-management-filters">
                        <Col className="form-group">
                            <Form.Group>
                                <Form.Control
                                    value={SearchName}
                                    onChange={(e) => setSearchName(e.target.value)}
                                    id="search"
                                    placeholder={t('search_by_name')} />
                            </Form.Group>
                        </Col>
                        <Col className="form-group">
                            <Form.Group>
                                <Form.Control
                                    value={SearchEmail}
                                    onChange={(e) => setSearchEmail(e.target.value)}
                                    id="search-email"
                                    placeholder={t('search_by_email')} />
                            </Form.Group>
                        </Col>
                    </Row>
                </section>
                <Card className="admin-data-card">
                    <table className="table mb-0 text-center">
                        <thead className="bg-light">
                            <tr>
                                <th scope="col" className="border-0">{t('name')}</th>
                                <th scope="col" className="border-0">{t('email')}</th>
                                <th scope="col" className="border-0">{t('country')}</th>
                                <th scope="col" className="border-0">{t('city')}</th>
                                <th scope="col" className="border-0">{t('mobile')}</th>
                                <th scope="col" className="border-0"></th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                filteredSuppliers.map(supplier => {
                                    return (
                                        <tr key={supplier.uid}>
                                            <td>{supplier.name}</td>
                                            <td>{supplier.email}</td>
                                            <td>{supplier.country}</td>
                                            <td>{supplier.city}</td>
                                            <td>{supplier.tel_mobile}</td>
                                            <td>
                                                <ButtonGroup size="sm" className="mr-2">
                                                    <Button title={t('edit')} onClick={() => getSingleSupplier(supplier.uid)}><i className="material-icons">&#xe3c9;</i></Button>
                                                    <Button title={t('feature_not_available')} disabled variant="danger"><i className="material-icons">&#xe872;</i></Button>
                                                </ButtonGroup>

                                            </td>
                                        </tr>

                                    )
                                })
                            }

                        </tbody>
                    </table>


                </Card>
            </Container>
            <Modal show={toggle} onHide={() => setToggle(false)}>
                <Modal.Header closeButton>
                    <h6 className="m-0">{t('edit_supplier')}</h6>
                </Modal.Header>
                <Modal.Body>
                    <Row form className="py-4 gap-2">
                        <Col lg="6" md="12" sm="12" >
                            <Form.Group>
                                <label htmlFor="name">{t('supplier_company_name')}</label>
                                <Form.Control
                                    id="name"
                                    placeholder={t('supplier_company_name')}
                                    onChange={(e) => setName(e.target.value)}
                                    value={name}
                                />
                            </Form.Group>
                            <Form.Group>
                                <label htmlFor="email">{t('email')}</label>
                                <Form.Control
                                    id="email"
                                    placeholder={t('email')}
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}

                                />
                            </Form.Group>
                            <Form.Group>
                                <label htmlFor="tel">{t('phone_number')}</label>
                                <Form.Control
                                    placeholder={t('phone_number')}
                                    type="tel"
                                    id="tel"
                                    value={mobilePhone}
                                    onChange={(e) => setMobilePhone(e.target.value)} />
                            </Form.Group>

                        </Col>
                        <Col lg="5" md="12" sm="12">
                            <Form.Group>
                                <label htmlFor="Address">{t('address')}</label>
                                <Form.Control
                                    id="Address"
                                    placeholder={t('address')}
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <label htmlFor="Country">{t('country')}</label>
                                <Form.Control
                                    id="Country"
                                    placeholder={t('country')}
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <label htmlFor="City">{t('city')}</label>
                                <Form.Control
                                    id="City"
                                    placeholder={t('city')}
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)} />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        onClick={() => setToggle(false)}
                    >
                        {t('cancel')}
                        <i className="fa fa-times mx-2"></i>
                    </Button>
                    <Button
                        variant="success"
                        onClick={() => editMySupplierData(SingleSupplier.uid)}
                    >
                        {t('save')}
                        <i className="fa fa-check mx-2"></i>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AllSuppliers